<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">Student ID</th>
          <th class="text-left">Name</th>
          <!-- <th class="text-left">Start time</th> -->
          <!-- <th class="text-left">Duration (minutes)</th>
          <th class="text-left">Freezed?</th>-->
        </tr>
      </thead>
      <tbody>
        <tr v-for="student in students" :key="student.id">
          <td>{{ student.id }}</td>
          <td>{{ student.sid }}</td>
          <td>{{ student.name }}</td>
          <td>
            <!-- <a href="/next">{{ exam.name }}</a> -->
            <router-link :to="'/showAnswer/' + id + '/' + student.id">See submission</router-link>
          </td>
          <!-- <td>{{ new Date(exam.startTime).toLocateDateString() }}</td> -->
          <!-- <td>{{ exam.duration }}</td> -->
        </tr>
      </tbody>
      <!--    <tfoot>
            <td colspan="2">
              
            </td>
      </tfoot>-->
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "ShowStudents",
  props: ["id"],

  data: () => ({
    panel: [],
    students: []
  }),

  async mounted() {
    alert("here");
    var response = await fetch(
      process.env.VUE_APP_API_BASE_URL + "/Exam/getStudents/" + this.id,
      {
        method: "GET",
        credentials: "include"
        //   headers: {
        //     "Content-Type": "application/json"
        //     // 'Content-Type': 'application/x-www-form-urlencoded',
        //   }
      }
    );

    if (response.ok) {
      var data = await response.json();
      console.log(data);

      this.students = data;
    } else {
      alert(response.status + ": " + response.statusText);
    }
  }
};
</script>
